module.exports = __webpack_public_path__ + "static/media/icon-mark-unread-hover.228cc856.svg";